import React, { useEffect, useState, useRef } from 'react'
import Modal from '../Modal'
import Button from '../Button'
import Typography from '../Typography'
import PTRestAPI from '../../utils/pt_rest_api'
import { useAuth } from '../../utils/platform_auth.jsx'
import DataTable from '../DataTable'
import ProgressBar from '../Progressbar'
import { showNotification } from '../Notification'

const resourceRender = [
  {
    id: 'filename',
    title: 'Filename',
    headerClassName: 'w-[100px]',
    render: (value) => {
      return (
        <div className="flex flex-row items-center">
          <Button
            variant="viewer_controls"
            onClick={() => {
              navigator.clipboard.writeText(value)
              showNotification({
                message: 'CDN Filename copied',
                className: 'bg-primary text-text_inv',
              })
            }}
          >
            Copy
          </Button>

          <Typography className="ml-2 text-text">{value}</Typography>
        </div>
      )
    },
  },
]

export default ({ isOpen, onCloseRequested }) => {
  const auth = useAuth()
  const [file, setFile] = useState(null)
  const [progress, setProgress] = useState(0)
  const fileInputRef = useRef(null)
  const [tableRefresh, setTableRefresh] = useState(false)

  const handleFileChange = (e) => {
    setFile(e.target.files[0])
  }

  const handleUpload = async () => {
    if (!file) return

    const formData = new FormData()
    formData.append('file', file)

    try {
      const result = await PTRestAPI.UploadArticleResource(
        auth,
        formData,
        setProgress,
      )

      // Show the result notification
      showNotification({
        message: result.error
          ? 'Failed to upload resource: ' + result.error
          : 'Resource uploaded',
        className: result.error
          ? 'bg-red-500 text-text_inv'
          : 'bg-primary text-text_inv',
      })

      // Clear the file input and reset state
      setFile(null)
      fileInputRef.current.value = ''
      setProgress(0)
      setTableRefresh(!tableRefresh)
    } catch (error) {
      showNotification({
        message: 'Failed to upload resource: ' + error.message,
        className: 'bg-red-500 text-text_inv',
      })
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onCloseRequested={onCloseRequested}
      closeOnEscape={true}
      className="w-full sm:w-[500px] md:absolute md:top-[65px] h-full md:h-auto sm:max-w-[700px] bg-paper text-sm sm:text-base z-200"
    >
      <div>
        <Typography variant="h3" className="text-text mb-4">
          Article Resources
        </Typography>
        <Typography className="text-text mb-4">
          Upload files and use them in your articles inside the cdn attribute
        </Typography>
        <p className="text-gray-400">Example: {`<img cdn="filename.png"/>`}</p>
        <div className="mb-4 flex flex-row items-center justify-center">
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
          />
          <Button
            variant="action"
            className="w-[120px] bg-blue-500 text-white mt-2"
            onClick={handleUpload}
            disabled={!file}
          >
            Upload
          </Button>
        </div>
        {progress > 0 && (
          <ProgressBar
            progress={progress}
            title={`Uploading... ${Math.round(progress * 100)}%`}
          />
        )}

        {/* File List */}
        <div className="min-h-[100px]">
          <DataTable
            title={'Resources'}
            refreshKey={tableRefresh}
            preferredHeight="400px"
            itemHeight="h-[20px]"
            apiMethod={PTRestAPI.ListArticleResources}
            searchField={'filename'}
            sort={{ created: 1 }}
            renders={resourceRender}
            noData={
              <Typography variant="h5" className="text-text">
                {`No resources`}
              </Typography>
            }
          />
        </div>
      </div>
    </Modal>
  )
}
